<template>
  <div class="admin-view-header">
    <p class="title is-unselectable">{{ title }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  name: "admin-view-header",

  props: {
    title: String
  }
};
</script>

<style lang="scss" scoped>
.admin-view-header {
  margin-bottom: 2rem;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;

  & > * {
    margin: 0 0.2rem;
  }

  .is-fullwidth {
    flex-grow: 2;
  }
}

.title {
  font-family: $family-sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  color: $grey-dark;
  margin: 0 0.5rem 0 0;
}
</style>
